import { useEffect, useState } from "react";
import { taskService } from "@miplatform/api";
import { ACTIVITY_CARD_CONFIG, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";

export const useHomeActivityDrawerViewModel = ({ home, open, search }) => {
  const stateManager = useComponentState();
  const [homeOrderActivities, setHomeOrderActivities] = useState([]);

  useEffect(() => {
    const fetchActivities = async (id) => {
      return stateManager.run(async () => {
        const { status, data = [] } = await taskService.activities.getByHomeId({
          id,
        });

        if (status === HTTP_STATUSES.OK) {
          setHomeOrderActivities(data);
          return data;
        }
        return [];
      });
    };

    if (open && home?.id) {
      fetchActivities(home.id);
    }
  }, [open, home?.id]);

  const filteredOrderActivities = homeOrderActivities.filter((activity) => {
    const { notes, reason, activityType, orderTemplateName, createdByUser } =
      activity || {};

    const searchLower = search.toLowerCase();

    return (
      createdByUser?.displayName?.toLowerCase().includes(searchLower) ||
      createdByUser?.tenantName?.toLowerCase().includes(searchLower) ||
      notes?.toLowerCase().includes(searchLower) ||
      reason?.toLowerCase().includes(searchLower) ||
      orderTemplateName?.toLowerCase().includes(searchLower) ||
      ACTIVITY_CARD_CONFIG[activityType]?.title
        ?.toLowerCase()
        ?.includes(searchLower)
    );
  });

  return {
    homeOrderActivities,
    filteredOrderActivities,
    isLoading: stateManager.isBusy(),
  };
};
